// src/components/AboutUsBanner.js
import React from 'react';
import './MarketingBanner.css'; // We’ll define styles separately

const MarketingBanner = () => {
  return (
    <div className="service-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">BTL AND ATL Activation</h2>
       
      </div>
    </div>
  );
};

export default MarketingBanner;
